import { FC } from 'react';
import { UserInfo } from '@components/UserInfo/UserInfo';
import { OptionRendererProps } from '@components/OptionRenderer/OptionRenderer';
import { UserItemForMembers } from '@dynamika-shared/types/users';
import { TeamMember } from '@dynamika-shared/types/teamMember';

type OptionMembersRendererProps = OptionRendererProps & {
  userMember?: UserItemForMembers | TeamMember;
  disabled?: boolean;
  hideActions?: boolean;
};
export const OptionMembersRenderer: FC<OptionMembersRendererProps> = ({
  option,
  selectedOptions,
  userMember,
  disabled,
  hideActions,
}) => {
  const isSelected = !!selectedOptions.find(
    item => item.value === option.value
  );

  const renderName = () => {
    if (hideActions) return null;
    if (isSelected) {
      return <span className='text-pastelBlue'>Added</span>;
    }
    if (!disabled) {
      return <span className='text-vividTangelo'>Add</span>;
    }
    return null;
  };
  return (
    <div className='flex items-center justify-between'>
      <UserInfo
        fullName={option.data.label}
        email={userMember?.email}
        enabled={!disabled}
      />
      {renderName()}
    </div>
  );
};
